import React from "react";
import { useSelector } from "react-redux";
import { Outlet } from "react-router-dom";
import LoaderCstm from "../../Loader";
import { wait } from "../../../helper/common";
import { Button, Col, Container, Row } from "react-bootstrap";
import styles from "./Authe.module.scss"

const AuthLayout = () => {
    const { loading } = useSelector(({ Auth }) => ({
        user: Auth.user
    }));
    // While checking auth, show a loading indicator
    if (loading) {
        return <LoaderCstm />;
    }

    wait(1000);
    return (
        <>
            {/* <main> */}
                <section
                    className={`${styles.authentication} authentication text-center py-5 position-relative d-flex align-items-center justify-content-center`}
                >
                    <Container>
                        <Row className="justify-content-center">
                            <Col lg="5" md="6" sm="10">
                                <div className={`${styles.authFormWrpper} p-4`}>
                                    <Outlet />
                                </div>
                            </Col>
                        </Row>
                    </Container>
                </section>
            {/* </main> */}
        </>
    );
};

export default AuthLayout;
